export default __webpack_public_path__ + "static/media/contacts-icon.cfffd0d5.svg";